export default {
    defaultProps: {
        component: "div",
    },
};
